import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch } from "react-redux";
import Joi from "joi";
import { getForm } from "../../actions/forms";
import BusinessCategory from "../ForPages/BusinessCategory";
import axiosInstance from "../../utils/config";
import { ClipLoader } from "react-spinners";
import { getState } from "../../actions/popup";
import PswdShown from "@material-ui/icons/Visibility";
import PswdHidden from "@material-ui/icons/VisibilityOff";
import { useSelector } from "react-redux";

function Register() {
    const dispatch = useDispatch();

    const [submitting, setSubmitting] = useState(false);
    const [categories, setCategories] = useState([]);
    const showCategories = useSelector((state) => state.popupOpen);
    const selectedCategories = useSelector((state) => state.categories);
    const [busCategoryError, setBusCategoryError] = useState("");

    const [successMsg, setSuccessMsg] = useState({ status: null, message: null }),
        [isPasswordShown, setIsPasswordShown] = useState(false),
        changePswdVisibility = (action) => {
            action === "hide" ? setIsPasswordShown(false) : setIsPasswordShown(true);
        };
    const [userInfo, setUserInfo] = useState({
        Names: "",
        Email: "",
        Password: "",
        BusinessCategory: [],
    });

    useEffect(() => {
        setUserInfo({ ...userInfo, BusinessCategory: selectedCategories });
    }, [selectedCategories]);

    useEffect(() => {
        document.title = "Register | Ski Design";
        axiosInstance
            .get("/categories")
            .then((data) => {
                console.log("nell'ys categories...", data.data)
                setCategories(data.data.data);
            })
            .catch((err) => {
                console.log("this is our error", err.message);
                console.log(err);
            });
    }, []);

    const [formErrors, setFormErrors] = useState({
        namesError: "",
        emailError: "",
        passwordError: ""
    });

    const schemaMap = {
        Names: Joi.string().required().max(40).min(3).label("Fullname field"),
        Password: Joi.string().required().max(25).min(6).label("Password field"),
        Email: Joi.string()
            .max(100)
            .min(3)
            .required()
            .email({ tlds: { allow: false } })
            .label("Email field"),
        BusinessCategory: Joi.array().required(),
    };

    const schema = Joi.object(schemaMap);

    const handleShowCategories = (e) => {
        e.preventDefault();
        dispatch(getState(true));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        const options = { abortEarly: false };
        const { error } = schema.validate(userInfo, options);
        if (error) {
            const errors = {};
            for (let item of error.details) {
                errors[item.path[0]] = item.message;
            }
            setFormErrors({
                namesError: errors.Names,
                emailError: errors.Email,
                passwordError: errors.Password,
            });
            setSubmitting(false);
        } else {
            setSuccessMsg({ status: null, message: null });
            setFormErrors({ namesError: "", emailError: "", passwordError: "", BusinessCategory: [] });
            axiosInstance
                .post("/register", userInfo)
                .then((data) => {
                    setSuccessMsg({ status: true, message: data.data.message });
                    setSubmitting(false);
                    setFormErrors({ namesError: "", emailError: "", passwordError: "", BusinessCategory: [] });
                })
                .catch((err) => {
                    if (err.response) {
                        setSuccessMsg({
                            status: false,
                            message: err.response.data,
                        });
                        setSubmitting(false);
                    }
                });
        }
    };

    return (
        <div className="form-container">
            {showCategories ? (
                <div className="business-category-popup">
                    <BusinessCategory allCategories={categories} />
                </div>
            ) : (
                ""
            )}
            <div className="upper-rotated-container"></div>
            <div style={{ top: "50%" }} className="form-cont position-relative">
                <h2 className="form-header">Create an account</h2>
                {successMsg.message && successMsg.status ? (
                    <div className="alert alert-success text-center" role="alert">
                        {successMsg.message}
                    </div>
                ) : (
                    ""
                )}
                {successMsg.message && !successMsg.status ? (
                    <div className="alert alert-danger text-center" role="alert">
                        {successMsg.message}
                    </div>
                ) : (
                    ""
                )}
                {formErrors.namesError ? (
                    <p className="my-3 error">{formErrors.namesError}</p>
                ) : formErrors.emailError ? (
                    <p className="my-3 error">{formErrors.emailError}</p>
                ) : formErrors.passwordError ? (
                    <p className="my-3 error">{formErrors.passwordError}</p>
                ) : busCategoryError && (
                    <p className="my-3 error">{busCategoryError}</p>
                )}
                <p className="under-header mb-3">
                    Create an account to enjoy all the services!
                </p>
                <form
                    autoComplete="off"
                    method="POST"
                    className="d-flex flex-column align-items-center justify-content-center"
                >
                    <input
                        type="text"
                        name="names"
                        placeholder="Full Name"
                        className="fullname my-2"
                        required={true}
                        value={userInfo.names}
                        onChange={(e) =>
                            setUserInfo({ ...userInfo, Names: e.target.value })
                        }
                    />
                    <input
                        type="email my-2"
                        required={true}
                        placeholder="Email Address"
                        className="email"
                        name="email"
                        value={userInfo.email}
                        onChange={(e) =>
                            setUserInfo({ ...userInfo, Email: e.target.value })
                        }
                    />
                    <div style={{ position: "relative" }}>
                        <input
                            type={isPasswordShown ? "text" : "password"}
                            value={userInfo.password}
                            onChange={(e) =>
                                setUserInfo({ ...userInfo, Password: e.target.value })
                            }
                            name="password"
                            required={true}
                            placeholder="Password"
                            className="password my-2"
                            autoComplete="off"
                        />
                        {isPasswordShown ? (
                            <PswdShown
                                titleAccess="Hide password"
                                className="pswdShowHide"
                                onClick={() => changePswdVisibility("hide")}
                            />
                        ) : (
                            <PswdHidden
                                titleAccess="Show password"
                                className="pswdShowHide"
                                onClick={() => changePswdVisibility("show")}
                            />
                        )}
                    </div>
                    <input
                        required={true}
                        // value={userInfo}
                        type="hidden"
                        className="choose-biz-category-btn"
                    />
                    <button
                        onClick={handleShowCategories}
                        className="choose-biz-category-btn"
                        title="Please select a business category"
                    >
                      <sup style={{ color: "crimson" }}>*</sup>Choose your Business Category
                    </button>
                    <button className="submit-btn" type="submit" disabled={!userInfo.BusinessCategory.length > 0} onClick={handleSubmit}>
                        {submitting ? (
                            <ClipLoader color="#fff" size={30} />
                        ) : (
                            "Create Account"
                        )}
                    </button>
                    <p className="arleady-have-acc">
                        Arleady have an account?{" "}
                        <span
                            className="link-text"
                            onClick={() => dispatch(getForm("login"))}
                        >
                            Sign In
                        </span>
                    </p>
                </form>
            </div>
            <div className="lower-rotated-container"></div>
        </div>
    );
}

export default Register;
